import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=544c3487&scoped=true&"
import script from "./AddModal.vue?vue&type=script&lang=js&"
export * from "./AddModal.vue?vue&type=script&lang=js&"
import style0 from "./AddModal.vue?vue&type=style&index=0&id=544c3487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c3487",
  null
  
)

export default component.exports